export default {
  // Common translations
  'common.cancel': '取消',
  'common.confirm': '確認',
  'common.save': '保存',
  'common.delete': '刪除',
  'common.edit': '編輯',
  'common.add': '添加',
  'common.search': '搜索',
  'common.reset': '重置',
  'common.submit': '提交',
  'common.close': '關閉',

  'pages.layouts.userLayout.title': 'Ant Design 是西湖區最具影響力的 Web 設計規範',
  'pages.login.accountLogin.tab': '賬戶密碼登錄',
  'pages.login.accountLogin.errorMessage': '錯誤的用戶名和密碼(admin/ant.design)',
  'pages.login.failure': '登錄失敗，請重試！',
  'pages.login.success': '登錄成功！',
  'pages.login.username.placeholder': '用戶名: admin or user',
  'pages.login.username.required': '用戶名是必填項！',
  'pages.login.password.placeholder': '密碼: ant.design',
  'pages.login.password.required': '密碼是必填項！',
  'pages.login.phoneLogin.tab': '手機號登錄',
  'pages.login.phoneLogin.errorMessage': '驗證碼錯誤',
  'pages.login.phoneNumber.placeholder': '請輸入手機號！',
  'pages.login.phoneNumber.required': '手機號是必填項！',
  'pages.login.phoneNumber.invalid': '不合法的手機號！',
  'pages.login.captcha.placeholder': '請輸入驗證碼！',
  'pages.login.captcha.required': '驗證碼是必填項！',
  'pages.login.phoneLogin.getVerificationCode': '獲取驗證碼',
  'pages.getCaptchaSecondText': '秒後重新獲取',
  'pages.login.rememberMe': '自動登錄',
  'pages.login.forgotPassword': '忘記密碼 ?',
  'pages.login.submit': '登錄',
  'pages.login.loginWith': '其他登錄方式 :',
  'pages.login.registerAccount': '註冊賬戶',
  'pages.welcome.link': '歡迎使用',
  'pages.welcome.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  'pages.admin.subPage.title': '這個頁面只有 admin 權限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 現已發佈，歡迎使用 npm run ui 啓動體驗。',
  'pages.searchTable.createForm.newRule': '新建規則',
  'pages.searchTable.updateForm.ruleConfig': '規則配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '規則名稱',
  'pages.searchTable.updateForm.ruleName.nameRules': '請輸入規則名稱！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '規則描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '請輸入至少五個字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '請輸入至少五個字符的規則描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置規則屬性',
  'pages.searchTable.updateForm.object': '監控對象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '規則模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '規則類型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '設定調度週期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '請選擇開始時間！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '規則名稱爲必填項',
  'pages.searchTable.titleCallNo': '服務調用次數',
  'pages.searchTable.titleStatus': '狀態',
  'pages.searchTable.nameStatus.default': '關閉',
  'pages.searchTable.nameStatus.running': '運行中',
  'pages.searchTable.nameStatus.online': '已上線',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '上次調度時間',
  'pages.searchTable.exception': '請輸入異常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '訂閱警報',
  'pages.searchTable.title': '查詢表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已選擇',
  'pages.searchTable.item': '項',
  'pages.searchTable.totalServiceCalls': '服務調用次數總計',
  'pages.searchTable.tenThousand': '萬',
  'pages.searchTable.batchDeletion': '批量刪除',
  'pages.searchTable.batchApproval': '批量審批',
  // Staff Management
  'pages.staffManagement.title': '員工管理',
  'pages.staffManagement.staffList': '員工列表',
  'pages.staffManagement.addStaff': '添加員工',
  'pages.staffManagement.editStaff': '編輯員工',
  'pages.staffManagement.exportExcel': '匯出Excel',
  'pages.staffManagement.exportTooltip': '匯出員工資料到Excel（CSV格式，UTF-8編碼）',
  'pages.staffManagement.exportSuccess':
    '員工列表匯出成功！為獲得最佳中文字元顯示，請在Excel中開啟並確保選擇UTF-8編碼。',
  'pages.staffManagement.staffCreated': '員工建立成功！',
  'pages.staffManagement.staffUpdated': '員工更新成功！',
  'pages.staffManagement.staffDeleted': '員工刪除成功！',
  'pages.staffManagement.deleteFailed': '刪除員工失敗',
  'pages.staffManagement.deleteStaff': '刪除員工',
  'pages.staffManagement.deleteConfirmTitle': '刪除員工',
  'pages.staffManagement.deleteConfirmDescription': '確定要刪除 {name} 嗎？此操作無法撤銷。',
  'pages.staffManagement.deleteConfirm': '是',
  'pages.staffManagement.deleteCancel': '否',
  'pages.staffManagement.viewAssignments': '查看員工排班',
  'pages.staffManagement.operationFailed': '操作失敗',
  'pages.staffManagement.accessDenied': '存取被拒絕',
  // Staff Form Fields
  'pages.staffManagement.employeeId': '員工編號',
  'pages.staffManagement.employeeIdPlaceholder': '搜尋員工編號',
  'pages.staffManagement.employeeIdRequired': '請輸入員工編號',
  'pages.staffManagement.firstName': '名字',
  'pages.staffManagement.firstNamePlaceholder': '搜尋名字',
  'pages.staffManagement.firstNameRequired': '請輸入名字',
  'pages.staffManagement.lastName': '姓氏',
  'pages.staffManagement.lastNamePlaceholder': '搜尋姓氏',
  'pages.staffManagement.lastNameRequired': '請輸入姓氏',
  'pages.staffManagement.name': '姓名',
  'pages.staffManagement.staffTitle': '稱謂',
  'pages.staffManagement.titlePlaceholder': '選擇稱謂',
  'pages.staffManagement.gender': '性別',
  'pages.staffManagement.genderPlaceholder': '選擇性別',
  'pages.staffManagement.male': '男',
  'pages.staffManagement.female': '女',
  'pages.staffManagement.other': '其他',
  'pages.staffManagement.phone': '電話',
  'pages.staffManagement.phonePlaceholder': '搜尋電話',
  'pages.staffManagement.hkidNumber': '香港身份證號碼',
  'pages.staffManagement.hkidNumberPlaceholder': '搜尋香港身份證',
  'pages.staffManagement.age': '年齡',
  'pages.staffManagement.securityLicense': '保安牌照',
  'pages.staffManagement.securityLicensePlaceholder': '搜尋牌照',
  'pages.staffManagement.securityLicenseNumber': '保安牌照號碼',
  'pages.staffManagement.securityLicenseAExpiry': '保安牌照A到期日',
  'pages.staffManagement.securityLicenseBExpiry': '保安牌照B到期日',
  'pages.staffManagement.qasCertificateIssueDate': 'QAS證書簽發日期',
  'pages.staffManagement.medicalReportIssueDate': '體檢報告簽發日期（65歲以上）',
  'pages.staffManagement.employmentStatus': '僱傭狀態',
  'pages.staffManagement.employmentStatusPlaceholder': '選擇狀態',
  'pages.staffManagement.contractType': '合約類型',
  'pages.staffManagement.contractTypePlaceholder': '選擇合約類型',
  'pages.staffManagement.contractTypeDescription': '合約類型描述',
  'pages.staffManagement.contractType.permanent': '長期（無固定期限）勞動合約',
  'pages.staffManagement.contractType.fixed_term': '固定期限勞動合約',
  'pages.staffManagement.contractType.temporary': '臨時勞動合約',
  'pages.staffManagement.contractType.part_time': '兼職勞動合約',
  'pages.staffManagement.contractType.casual': '零工勞動合約',

  // Site Gate Management
  'siteDetail.gateManagementTitle': '門禁管理',
  'siteDetail.addGate': '添加門禁',
  'siteDetail.editGate': '編輯門禁',
  'siteDetail.deleteGate': '刪除門禁',
  'siteDetail.gateName': '門禁名稱',
  'siteDetail.gateType': '門禁類型',
  'siteDetail.passcode': '門禁密碼',
  'siteDetail.gateType.main': '主門',
  'siteDetail.gateType.service': '服務門',
  'siteDetail.gateType.emergency': '緊急門',
  'siteDetail.gateType.pedestrian': '人行門',
  'siteDetail.gateType.vehicle': '車輛門',
  'siteDetail.gateCreated': '門禁建立成功！',
  'siteDetail.gateUpdated': '門禁更新成功！',
  'siteDetail.gateDeleted': '門禁刪除成功！',
  'siteDetail.gateDeleteFailed': '刪除門禁失敗',
  'siteDetail.gateOperationFailed': '門禁操作失敗',
  'siteDetail.deleteGateConfirmTitle': '刪除門禁',
  'siteDetail.deleteGateConfirmDescription': '確定要刪除此門禁嗎？此操作無法撤銷。',
  'siteDetail.deleteGateConfirm': '是',
  'siteDetail.deleteGateCancel': '否',
  'siteDetail.gateNameRequired': '請輸入門禁名稱',
  'siteDetail.gateTypeRequired': '請選擇門禁類型',

  // Shift Assignment Import
  'shiftAssignment.clearAndReplaceMode': '清除並替換模式',
  'shiftAssignment.clearAndReplaceDescription':
    '在匯入新資料之前，已清除本月的現有排班和請假記錄。',
  'shiftAssignment.clearedData': '已清除資料',
  'shiftAssignment.clearedAssignments': '已清除排班',
  'shiftAssignment.clearedLeaves': '已清除請假',
  'shiftAssignment.assignments': '排班',
  'shiftAssignment.leaves': '請假',
  'shiftAssignment.totalLeaves': '總請假數',
  'shiftAssignment.createdLeaves': '已建立請假',
  'shiftAssignment.skippedLeaves': '已跳過請假',
  'shiftAssignment.totalConflicts': '總衝突數',

  // Shift Assignment Export
  'shiftAssignment.exportExcel': '匯出Excel',
  'shiftAssignment.exportSuccess': '匯出成功',
  'shiftAssignment.exportError': '匯出失敗',
  'shiftAssignment.siteName': '站點名稱',
  'shiftAssignment.shiftName': '班次名稱',
  'shiftAssignment.timeRange': '時間範圍',
  'shiftAssignment.region': '區域',
  'shiftAssignment.district': '地區',
  'shiftAssignment.fileTooLarge': '檔案必須小於50MB！',
  'shiftAssignment.fileRequirements': '支援 .xlsx 和 .xls 檔案，最大50MB',

  // Additional Shift Assignment keys
  'shiftAssignment.siteShift': '站點 - 班次',
  'shiftAssignment.sunday': '週日',
  'shiftAssignment.originalName': '原始名稱',
  'shiftAssignment.monthPicker': '選擇月份',
  'shiftAssignment.filterByRegion': '按區域篩選',
  'shiftAssignment.filterByDistrict': '按地區篩選',
  'shiftAssignment.filterBySite': '按站點篩選',
  'shiftAssignment.legend': '圖例',
  'shiftAssignment.holidayName': '節假日名稱',
  'shiftAssignment.noSites': '未找到站點',
  'shiftAssignment.import': '匯入',
  'shiftAssignment.selectFile': '選擇Excel文件',
  'shiftAssignment.importResult': '匯入結果',
  'shiftAssignment.totalAssignments': '總排班數',
  'shiftAssignment.createdAssignments': '已建立排班',
  'shiftAssignment.skippedAssignments': '已跳過排班',
  'shiftAssignment.conflicts': '衝突',
  'shiftAssignment.conflictDetails': '衝突詳情',
  'shiftAssignment.staff': '員工',
  'shiftAssignment.site': '站點',
  'shiftAssignment.shift': '班次',
  'shiftAssignment.date': '日期',
  'shiftAssignment.importSuccess': '匯入成功',
  'shiftAssignment.importWithConflicts': '匯入完成，但有衝突',
  'shiftAssignment.importError': '匯入失敗',
  'shiftAssignment.invalidFileType': '只能上傳Excel文件！',
  'shiftAssignment.noFileSelected': '請選擇要匯入的文件',

  // Shift Detail
  'shiftDetail.updateLeave': '更新請假',
  'shiftDetail.deleteLeave': '刪除請假',
  'shiftDetail.sunday': '週日',
  'shiftDetail.backToShiftAssignment': '返回排班管理',
  'shiftDetail.legend': '圖例',
  'shiftDetail.holiday': '節假日',
  'shiftDetail.regularDay': '工作日',
  'shiftDetail.statutoryHoliday': '法定節假日',
  'shiftDetail.noPayLeave': '無薪假',
  'shiftDetail.regularHoliday': '常規假期',
  'shiftDetail.compensationLeave': '補假',
  'shiftDetail.absenceWithoutLeave': '曠工',
  'shiftDetail.unpaidSickLeave': '無薪病假',

  'pages.staffManagement.employmentStartDate': '僱傭開始日期',
  'pages.staffManagement.employmentEndDate': '僱傭結束日期',
  'pages.staffManagement.employmentStartRange': '僱傭開始日期範圍',
  'pages.staffManagement.licenseAExpiryRange': '牌照A到期日期範圍',
  'pages.staffManagement.site': '工作地點',
  'pages.staffManagement.sitePlaceholder': '按工作地點篩選',
  'pages.staffManagement.address': '地址',
  'pages.staffManagement.emergencyContact': '緊急聯絡人',
  'pages.staffManagement.emergencyPhone': '緊急聯絡電話',
  'pages.staffManagement.email': '電子郵件',
  'pages.staffManagement.emailInvalid': '請輸入有效的電子郵件地址',
  'pages.staffManagement.password': '密碼',
  'pages.staffManagement.active': '啟用',
  'pages.staffManagement.inactive': '未啟用',
  'pages.staffManagement.status': '狀態',
  'pages.staffManagement.createdAt': '建立時間',
  'pages.staffManagement.updatedAt': '更新時間',
  // Employment Status
  'pages.staffManagement.statusActive': '在職',
  'pages.staffManagement.statusResigned': '已辭職',
  'pages.staffManagement.statusTerminated': '已終止',
  // Date Placeholders
  'pages.staffManagement.startDate': '開始日期',
  'pages.staffManagement.endDate': '結束日期',
  'pages.staffManagement.dateOfBirth': '出生日期',
  // Site Notice Management
  'pages.siteNoticeManagement.pageTitle': '物業通知',
  'pages.siteNoticeManagement.noticeList': '通知列表',
  'pages.siteNoticeManagement.addNotice': '添加通知',
  'pages.siteNoticeManagement.editNotice': '編輯通知',
  'pages.siteNoticeManagement.deleteNotice': '刪除通知',
  'pages.siteNoticeManagement.noticeCreated': '通知創建成功！',
  'pages.siteNoticeManagement.noticeUpdated': '通知更新成功！',
  'pages.siteNoticeManagement.noticeDeleted': '通知刪除成功！',
  'pages.siteNoticeManagement.operationFailed': '操作失敗',
  'pages.siteNoticeManagement.confirmDelete': '確定要刪除這個通知嗎？',
  'pages.siteNoticeManagement.confirmDeleteTitle': '刪除通知',
  // Site Notice Form Fields
  'pages.siteNoticeManagement.title': '標題',
  'pages.siteNoticeManagement.titlePlaceholder': '輸入通知標題',
  'pages.siteNoticeManagement.titleRequired': '請輸入通知標題',
  'pages.siteNoticeManagement.content': '內容',
  'pages.siteNoticeManagement.contentPlaceholder': '輸入通知內容',
  'pages.siteNoticeManagement.contentRequired': '請輸入通知內容',
  'pages.siteNoticeManagement.site': '物業',
  'pages.siteNoticeManagement.sitePlaceholder': '選擇物業',
  'pages.siteNoticeManagement.siteRequired': '請選擇一個物業',
  'pages.siteNoticeManagement.priority': '優先級',
  'pages.siteNoticeManagement.priorityPlaceholder': '選擇優先級',
  'pages.siteNoticeManagement.priorityLow': '低',
  'pages.siteNoticeManagement.priorityNormal': '普通',
  'pages.siteNoticeManagement.priorityHigh': '高',
  'pages.siteNoticeManagement.priorityUrgent': '緊急',
  'pages.siteNoticeManagement.isPublished': '已發布',
  'pages.siteNoticeManagement.isActive': '激活',
  'pages.siteNoticeManagement.expiresAt': '過期時間',
  'pages.siteNoticeManagement.expiresAtPlaceholder': '選擇過期日期',
  'pages.siteNoticeManagement.attachments': '附件',
  'pages.siteNoticeManagement.addAttachment': '添加附件',
  'pages.siteNoticeManagement.removeAttachment': '移除附件',
  'pages.siteNoticeManagement.noAttachments': '無附件',
  // Site Notice Table Columns
  'pages.siteNoticeManagement.columnTitle': '標題',
  'pages.siteNoticeManagement.columnSite': '物業',
  'pages.siteNoticeManagement.columnPriority': '優先級',
  'pages.siteNoticeManagement.columnStatus': '狀態',
  'pages.siteNoticeManagement.columnPublished': '發布狀態',
  'pages.siteNoticeManagement.columnCreatedBy': '創建者',
  'pages.siteNoticeManagement.columnCreatedAt': '創建時間',
  'pages.siteNoticeManagement.columnExpiresAt': '過期時間',
  'pages.siteNoticeManagement.columnActions': '操作',
  // Site Notice Status
  'pages.siteNoticeManagement.statusPublished': '已發布',
  'pages.siteNoticeManagement.statusDraft': '草稿',
  'pages.siteNoticeManagement.statusActive': '激活',
  'pages.siteNoticeManagement.statusInactive': '未激活',
  'pages.siteNoticeManagement.statusExpired': '已過期',
  // Site Notice Priority Colors
  'pages.siteNoticeManagement.priorityColorLow': 'blue',
  'pages.siteNoticeManagement.priorityColorNormal': 'green',
  'pages.siteNoticeManagement.priorityColorHigh': 'orange',
  'pages.siteNoticeManagement.priorityColorUrgent': 'red',
  // Site Document Management
  'pages.siteDetail.siteDocuments': '物業文檔',
  'pages.siteDetail.siteDocuments.create': '上傳文檔',
  'pages.siteDetail.siteDocuments.edit': '編輯文檔',
  'pages.siteDetail.siteDocuments.title': '標題',
  'pages.siteDetail.siteDocuments.description': '描述',
  'pages.siteDetail.siteDocuments.documentType': '文檔類型',
  'pages.siteDetail.siteDocuments.file': '文件',
  'pages.siteDetail.siteDocuments.fileOptional': '可選：您可以為本文檔添加文件附件',
  'pages.siteDetail.siteDocuments.expiryDays': '過期天數',
  'pages.siteDetail.siteDocuments.expiryDate': '過期日期',
  'pages.siteDetail.siteDocuments.expiryDatePlaceholder': '選擇過期日期和時間（可選）',
  'pages.siteDetail.siteDocuments.isActive': '激活',
  'pages.siteDetail.siteDocuments.isPublic': '公開',
  'pages.siteDetail.siteDocuments.isExpired': '已過期',
  'pages.siteDetail.siteDocuments.daysUntilExpiry': '距離過期天數',
  'pages.siteDetail.siteDocuments.isExpiringSoon': '即將過期',
  'pages.siteDetail.siteDocuments.createdBy': '創建者',
  'pages.siteDetail.siteDocuments.createdAt': '創建時間',
  'pages.siteDetail.siteDocuments.actions': '操作',
  'pages.siteDetail.siteDocuments.download': '下載',
  'pages.siteDetail.siteDocuments.removeAttachment': '移除附件',
  'pages.siteDetail.siteDocuments.replaceAttachment': '替換附件',
  'pages.siteDetail.siteDocuments.newFileSelected': '已選擇新文件',
  'pages.siteDetail.siteDocuments.attachmentRemoved': '附件移除成功',
  'pages.siteDetail.siteDocuments.attachmentReplaced': '附件替換成功',
  'pages.siteDetail.siteDocuments.actions.edit': '編輯',
  'pages.siteDetail.siteDocuments.actions.delete': '刪除',
  'pages.siteDetail.siteDocuments.actions.download': '下載',
  'pages.siteDetail.siteDocuments.deleteConfirm': '確定要刪除這個文檔嗎？',
  'pages.siteDetail.siteDocuments.deleteSuccess': '文檔刪除成功',
  'pages.siteDetail.siteDocuments.createSuccess': '文檔上傳成功',
  'pages.siteDetail.siteDocuments.updateSuccess': '文檔更新成功',
  'pages.siteDetail.siteDocuments.downloadSuccess': '文檔下載已開始',
  'pages.siteDetail.siteDocuments.documentType.license': '許可證',
  'pages.siteDetail.siteDocuments.documentType.contract': '合同',
  'pages.siteDetail.siteDocuments.documentType.permit': '許可證',
  'pages.siteDetail.siteDocuments.documentType.certificate': '證書',
  'pages.siteDetail.siteDocuments.documentType.managementCompany': '管理公司',
  'pages.siteDetail.siteDocuments.documentType.publicLiabilityInsurance': '大廈公眾責任保險',
  'pages.siteDetail.siteDocuments.documentType.propertyAllRisksInsurance': '大廈財產全險',
  'pages.siteDetail.siteDocuments.documentType.thirdPartyLiabilityInsurance': '大廈第三者責任保險',
  'pages.siteDetail.siteDocuments.documentType.fireInsurance': '大廈火保險',
  'pages.siteDetail.siteDocuments.documentType.workersCompensationInsurance': '大廈勞工保險',
  'pages.siteDetail.siteDocuments.documentType.elevatorMaintenance': '升降機保養',
  'pages.siteDetail.siteDocuments.documentType.elevatorLicense': '升降機行車證',
  'pages.siteDetail.siteDocuments.documentType.fireSafetyAnnualInspection': '消防年檢',
  'pages.siteDetail.siteDocuments.documentType.cleaningCompanyContract': '清潔公司合約',
  'pages.siteDetail.siteDocuments.documentType.fireAlarmCompany': '消防設備供應商',
  'pages.siteDetail.siteDocuments.documentType.cctvMaintenance': '閉路電視監察系統保養',
  'pages.siteDetail.siteDocuments.documentType.freshWaterTankCleaning': '食水缸清洗',
  'pages.siteDetail.siteDocuments.documentType.saltWaterTankCleaning': '鹹水缸清洗',
  'pages.siteDetail.siteDocuments.documentType.fireTankCleaning': '消防缸清洗',
  'pages.siteDetail.siteDocuments.documentType.fiveYearElectricalTest': '五年固定電力測試(WR2)',
  'pages.siteDetail.siteDocuments.documentType.governmentOrder': '政府命令',
  'pages.siteDetail.siteDocuments.documentType.meetingMinutes': '會議記錄',
  'pages.siteDetail.siteDocuments.documentType.expenseReport': '開支表',
  'pages.siteDetail.siteDocuments.documentType.managementFeeReport': '管理費報表',
  'pages.siteDetail.siteDocuments.documentType.emergencyNotice': '緊急通告',
  'pages.siteDetail.siteDocuments.documentType.importantNotes': '注意事項',
  'pages.siteDetail.siteDocuments.documentType.other': '其他',
  'pages.siteDetail.siteDocuments.attachment': '附件',
  'pages.siteDetail.siteDocuments.noAttachment': '無附件',
  // Patrol Route Management
  'pages.siteDetail.patrolRouteManagementTitle': '巡邏路線',
  'pages.siteDetail.addPatrolRoute': '添加巡邏路線',
  'pages.siteDetail.editPatrolRoute': '編輯巡邏路線',
  'pages.siteDetail.deletePatrolRoute': '刪除巡邏路線',
  'pages.siteDetail.patrolRouteName': '路線名稱',
  'pages.siteDetail.patrolRouteDescription': '描述',
  'pages.siteDetail.daysEnabled': '啟用日期',
  'pages.siteDetail.monday': '星期一',
  'pages.siteDetail.tuesday': '星期二',
  'pages.siteDetail.wednesday': '星期三',
  'pages.siteDetail.thursday': '星期四',
  'pages.siteDetail.friday': '星期五',
  'pages.siteDetail.saturday': '星期六',
  'pages.siteDetail.sunday': '星期日',
  'pages.siteDetail.manageCheckpoints': '管理檢查點',
  'pages.siteDetail.patrolRouteCreated': '巡邏路線創建成功',
  'pages.siteDetail.patrolRouteUpdated': '巡邏路線更新成功',
  'pages.siteDetail.patrolRouteDeleted': '巡邏路線刪除成功',
  'pages.siteDetail.confirmDeletePatrolRoute': '確定要刪除這個巡邏路線嗎？',
  'pages.siteDetail.confirmDeletePatrolRouteTitle': '刪除巡邏路線',
  // 住戶管理
  'tenantManagement.title': '住戶管理',
  'tenantManagement.content': '管理系統住戶及其資訊',
  'tenantManagement.tenantList': '住戶列表',
  'tenantManagement.createNewTenant': '建立新住戶',
  'tenantManagement.createTenant': '建立住戶',
  'tenantManagement.editTenant': '編輯住戶',
  'tenantManagement.deleteTenant': '刪除住戶',
  'tenantManagement.viewTenant': '檢視住戶',
  'tenantManagement.tenantCreated': '住戶建立成功',
  'tenantManagement.tenantUpdated': '住戶更新成功',
  'tenantManagement.tenantDeleted': '住戶刪除成功',
  'tenantManagement.saveTenantFailed': '儲存住戶失敗',
  'tenantManagement.deleteTenantFailed': '刪除住戶失敗',
  'tenantManagement.fetchSitesFailed': '取得物業失敗',
  'tenantManagement.userAccountCreated': '使用者帳戶已建立，請儲存憑證。',
  'tenantManagement.accessDenied': '存取被拒絕',
  // 住戶表單欄位
  'tenantManagement.name': '姓名',
  'tenantManagement.searchName': '依姓名搜尋',
  'tenantManagement.pleaseInputName': '請輸入住戶姓名',
  'tenantManagement.email': '電子郵件',
  'tenantManagement.searchEmail': '依電子郵件搜尋',
  'tenantManagement.pleaseInputEmail': '請輸入電子郵件',
  'tenantManagement.pleaseInputValidEmail': '請輸入有效的電子郵件',
  'tenantManagement.phone': '電話',
  'tenantManagement.searchPhone': '依電話搜尋',
  'tenantManagement.pleaseInputPhone': '請輸入電話號碼',
  'tenantManagement.leaseStart': '租約開始',
  'tenantManagement.leaseStartDate': '租約開始日期',
  'tenantManagement.pleaseInputLeaseStart': '請輸入租約開始日期',
  'tenantManagement.leaseEnd': '租約結束',
  'tenantManagement.leaseEndDate': '租約結束日期',
  'tenantManagement.monthlyRent': '月租金',
  'tenantManagement.depositAmount': '押金金額',
  'tenantManagement.emergencyContactName': '緊急聯絡人姓名',
  'tenantManagement.emergencyContactPhone': '緊急聯絡人電話',
  'tenantManagement.notes': '備註',
  'tenantManagement.units': '單位',
  'tenantManagement.assignUnits': '分配單位',
  'tenantManagement.selectUnits': '選擇要分配的單位',
  'tenantManagement.status': '狀態',
  'tenantManagement.active': '活躍',
  'tenantManagement.inactive': '非活躍',
  'tenantManagement.createdAt': '建立時間',
  'tenantManagement.actions': '操作',
  // 住戶模態框
  'tenantManagement.delete': '刪除',
  'tenantManagement.cancel': '取消',
  'tenantManagement.deleteConfirmation': '您確定要刪除此住戶嗎？此操作無法復原。',
  'tenantManagement.userAccountCreatedTitle': '使用者帳戶已建立：',

  // Site Event Calendar
  'pages.siteDetail.eventCalendar.title': '物業事件日曆',
  'pages.siteDetail.eventCalendar.addEvent': '新增事件',
  'pages.siteDetail.eventCalendar.createEvent': '建立事件',
  'pages.siteDetail.eventCalendar.editEvent': '編輯事件',
  'pages.siteDetail.eventCalendar.deleteEvent': '刪除事件',
  'pages.siteDetail.eventCalendar.deleteConfirm': '確定要刪除這個事件嗎？',
  'pages.siteDetail.eventCalendar.delete': '刪除事件',
  'pages.siteDetail.eventCalendar.deleteSuccess': '事件刪除成功',
  'pages.siteDetail.eventCalendar.createSuccess': '事件建立成功',
  'pages.siteDetail.eventCalendar.updateSuccess': '事件更新成功',
  'pages.siteDetail.eventCalendar.operationFailed': '操作失敗',
  'pages.siteDetail.eventCalendar.fetchFailed': '取得事件失敗',

  // Event Form Fields
  'pages.siteDetail.eventCalendar.form.title': '標題',
  'pages.siteDetail.eventCalendar.form.titlePlaceholder': '輸入事件標題',
  'pages.siteDetail.eventCalendar.form.titleRequired': '標題為必填項',
  'pages.siteDetail.eventCalendar.form.description': '描述',
  'pages.siteDetail.eventCalendar.form.descriptionPlaceholder': '輸入事件描述',
  'pages.siteDetail.eventCalendar.form.eventType': '事件類型',
  'pages.siteDetail.eventCalendar.form.eventTypePlaceholder': '選擇事件類型',
  'pages.siteDetail.eventCalendar.form.eventTypeRequired': '事件類型為必填項',
  'pages.siteDetail.eventCalendar.form.startDate': '開始日期',
  'pages.siteDetail.eventCalendar.form.startDatePlaceholder': '選擇開始日期',
  'pages.siteDetail.eventCalendar.form.startDateRequired': '開始日期為必填項',
  'pages.siteDetail.eventCalendar.form.endDate': '結束日期',
  'pages.siteDetail.eventCalendar.form.endDatePlaceholder': '選擇結束日期',
  'pages.siteDetail.eventCalendar.form.endDateRequired': '結束日期為必填項',
  'pages.siteDetail.eventCalendar.form.fullDay': '全天事件',
  'pages.siteDetail.eventCalendar.form.startTime': '開始時間',
  'pages.siteDetail.eventCalendar.form.startTimePlaceholder': '選擇開始時間',
  'pages.siteDetail.eventCalendar.form.endTime': '結束時間',
  'pages.siteDetail.eventCalendar.form.endTimePlaceholder': '選擇結束時間',
  'pages.siteDetail.eventCalendar.form.location': '地點',
  'pages.siteDetail.eventCalendar.form.locationPlaceholder': '輸入事件地點',
  'pages.siteDetail.eventCalendar.form.color': '顏色',
  'pages.siteDetail.eventCalendar.form.priority': '優先級',
  'pages.siteDetail.eventCalendar.form.priorityPlaceholder': '選擇優先級',
  'pages.siteDetail.eventCalendar.form.status': '狀態',
  'pages.siteDetail.eventCalendar.form.statusPlaceholder': '選擇狀態',
  'pages.siteDetail.eventCalendar.form.assignedTo': '分配給',
  'pages.siteDetail.eventCalendar.form.assignedToPlaceholder': '選擇分配的員工',
  'pages.siteDetail.eventCalendar.form.isPublic': '公開事件',
  'pages.siteDetail.eventCalendar.form.isActive': '啟用',
  'pages.siteDetail.eventCalendar.form.isRecurring': '重複',
  'pages.siteDetail.eventCalendar.form.recurrenceRule': '重複規則',
  'pages.siteDetail.eventCalendar.form.recurrenceRulePlaceholder': '例如：FREQ=MONTHLY;INTERVAL=1',

  // Event Types
  'pages.siteDetail.eventCalendar.eventType.maintenance': '維護',
  'pages.siteDetail.eventCalendar.eventType.inspection': '檢查',
  'pages.siteDetail.eventCalendar.eventType.visit': '訪問',
  'pages.siteDetail.eventCalendar.eventType.holiday': '假期',
  'pages.siteDetail.eventCalendar.eventType.custom': '自訂',

  // Priority Levels
  'pages.siteDetail.eventCalendar.priority.low': '低',
  'pages.siteDetail.eventCalendar.priority.normal': '一般',
  'pages.siteDetail.eventCalendar.priority.high': '高',
  'pages.siteDetail.eventCalendar.priority.urgent': '緊急',

  // Event Statuses
  'pages.siteDetail.eventCalendar.status.scheduled': '已安排',
  'pages.siteDetail.eventCalendar.status.inProgress': '進行中',
  'pages.siteDetail.eventCalendar.status.completed': '已完成',
  'pages.siteDetail.eventCalendar.status.cancelled': '已取消',

  // Transaction Categories
  'transaction.category.income': '收入',
  'transaction.category.investmentIncome': '投資收益',
  'transaction.category.interest': '利息',
  'transaction.category.capitalGains': '資本收益',
  'transaction.category.dividends': '股息',
  'transaction.category.rentIncome': '租金收入',
  'transaction.category.equipmentRental': '設備租金',
  'transaction.category.residentialRent': '住宅租金',
  'transaction.category.commercialRent': '商業租金',
  'transaction.category.otherIncome': '其他收入',
  'transaction.category.donationsReceived': '收到的捐贈',
  'transaction.category.grants': '補助金',
  'transaction.category.miscellaneousIncome': '雜項收入',
  'transaction.category.royalties': '版稅',
  'transaction.category.sales': '銷售',
  'transaction.category.productSales': '產品銷售',
  'transaction.category.onlineSales': '網上銷售',
  'transaction.category.serviceSales': '服務銷售',
  'transaction.category.wholesaleSales': '批發銷售',

  // Expense Categories
  'transaction.category.expenses': '支出',
  'transaction.category.operatingExpenses': '營運支出',
  'transaction.category.rent': '租金',
  'transaction.category.officeRent': '辦公室租金',
  'transaction.category.warehouseRent': '倉庫租金',
  'transaction.category.equipmentLease': '設備租賃',
  'transaction.category.salariesWages': '薪資工資',
  'transaction.category.fullTimeEmployees': '全職員工',
  'transaction.category.contractors': '承包商',
  'transaction.category.partTimeEmployees': '兼職員工',
  'transaction.category.advertisingMarketing': '廣告行銷',
  'transaction.category.digitalAdvertising': '數位廣告',
  'transaction.category.eventSponsorships': '活動贊助',
  'transaction.category.printAdvertising': '印刷廣告',
  'transaction.category.financialExpenses': '財務支出',
  'transaction.category.loanInterest': '貸款利息',
  'transaction.category.creditCardCharges': '信用卡費用',
  'transaction.category.bankFees': '銀行費用',
  'transaction.category.depreciationAmortization': '折舊攤銷',
  'transaction.category.equipmentDepreciation': '設備折舊',
  'transaction.category.buildingDepreciation': '建築折舊',
  'transaction.category.otherExpenses': '其他支出',
  'transaction.category.taxes': '稅款',
  'transaction.category.salesTax': '銷售稅',
  'transaction.category.incomeTax': '所得稅',
  'transaction.category.propertyTax': '物業稅',
  'transaction.category.miscellaneousExpenses': '雜項支出',
  'transaction.category.repairsMaintenance': '維修保養',
  'transaction.category.administrativeExpenses': '行政支出',
  'transaction.category.officeSupplies': '辦公用品',
  'transaction.category.utilities': '公用事業',
  'transaction.category.internetPhone': '網路電話',
  'transaction.category.electricity': '電力',
  'transaction.category.water': '水費',
  'transaction.category.professionalFees': '專業費用',
  'transaction.category.accountingFees': '會計費用',
  'transaction.category.legalFees': '法律費用',

  // Transaction Detail Modal
  'transaction.details': '詳細資料',
  'transaction.viewDetails': '查看詳細資料',
  'transaction.detailTitle': '出入帳詳細資料',
  'transaction.close': '關閉',
  'transaction.openFullSize': '開啟全尺寸',
  'transaction.viewImage': '查看圖片',
  'transaction.approve': '批准',
  'transaction.reject': '拒絕',
  'transaction.cancel': '取消',
  'transaction.approveSuccess': '出入帳批准成功',
  'transaction.rejectSuccess': '出入帳拒絕成功',
  'transaction.cancelSuccess': '出入帳取消成功',
  'transaction.confirmApproveTitle': '確認批准',
  'transaction.confirmApproveContent': '您確定要批准此出入帳嗎？此操作無法撤銷。',
  'transaction.confirmRejectTitle': '確認拒絕',
  'transaction.confirmRejectContent': '您確定要拒絕此出入帳嗎？此操作無法撤銷。',
  'transaction.confirmCancelTitle': '確認取消',
  'transaction.confirmCancelContent': '您確定要取消此出入帳嗎？此操作無法撤銷。',
  'transaction.transactionDetails': '出入帳詳情',
  'transaction.noDescription': '無描述',
  'transaction.cancelAction': '取消',
  'occurrenceBook.title': 'ob簿',
  'occurrenceBookRecord.title': 'ob簿記錄',
  'unitModal.unitNumber': '單位編號',
  'patrolRoute.modalTitle': '巡邏路線',
  'patrolRoute.name': '路線名稱',
  'patrolRoute.nameRequired': '路線名稱必填',
  'patrolRoute.namePlaceholder': '請輸入路線名稱',
  'patrolRoute.description': '描述',
  'patrolRoute.descriptionPlaceholder': '請輸入描述',
  'patrolRoute.daysEnabled': '啟用天數',
  'patrolRoute.monday': '星期一',
  'patrolRoute.tuesday': '星期二',
  'patrolRoute.wednesday': '星期三',
  'patrolRoute.thursday': '星期四',
  'patrolRoute.friday': '星期五',
  'patrolRoute.saturday': '星期六',
  'patrolRoute.sunday': '星期日',
  'patrolRoute.sequence': '順序',
  'patrolRoute.checkpoint': '檢查點',
  'patrolRoute.referenceCode': '參考代碼',
  'patrolRoute.expectedTime': '預期時間',
  'patrolRoute.tolerance': '容差',
  'patrolRoute.required': '必填',
  'patrolRoute.notes': '備註',
  'patrolRoute.action': '操作',
  'patrolRoute.checkpointsTitle': '檢查點',
  'patrolRoute.addCheckpoint': '新增檢查點',
  'patrolRoute.checkpointModalTitle': '檢查點詳情',
  'patrolRoute.checkpointRequired': '檢查點必填',
  'patrolRoute.selectCheckpoint': '選擇檢查點',
  'patrolRoute.expectedTimeRequired': '預期時間必填',
  'siteDetail.addDevice': '新增設備',
  'siteDetail.deviceName': '設備名稱',
  'siteDetail.deviceNameRequired': '設備名稱必填',
  'siteDetail.deviceType': '設備類型',
  'siteDetail.deviceTypeRequired': '設備類型必填',
  'siteDetail.deviceModel': '設備型號',
  'siteDetail.deviceSerial': '設備序號',
  'siteDetail.macAddress': 'MAC地址',
  'siteDetail.ipAddress': 'IP地址',
  'siteDetail.locationDescription': '位置描述',
  'siteDetail.floorLevel': '樓層',
  'siteDetail.zoneArea': '區域',
  'siteDetail.username': '用戶名',
  'siteDetail.usernameRequired': '用戶名必填',
  'siteDetail.email': '電子郵件',
  'siteDetail.emailRequired': '電子郵件必填',
  'siteDetail.password': '密碼',
  'siteDetail.passwordRequired': '密碼必填',
  'siteDetail.autoLogin': '自動登入',
  'siteDetail.offlineMode': '離線模式',
  'siteDetail.syncInterval': '同步間隔',
  'siteDetail.installationDate': '安裝日期',
  'siteDetail.warrantyExpiry': '保固到期',
  'siteDetail.maintenanceSchedule': '維護計劃',
  'siteDetail.notes': '備註',
  'siteDetail.installationNotes': '安裝備註',
  'siteDetail.troubleshootingNotes': '故障排除備註',
  'siteDetail.deviceStatus': '設備狀態',
  'siteDetail.accessLevel': '存取等級',
  'siteDetail.authToken': '認證令牌',
  'siteDetail.lastHeartbeat': '最後心跳',
  'siteDetail.actions': '操作',
  'siteDetail.incidentManagement': '事件管理',
  'siteDetail.patrolRouteManagementTitle': '巡邏路線管理',
  'siteDetail.daysEnabled': '啟用天數',
  'siteDetail.deviceManagement': '設備管理',
  'siteDetail.startTime': '開始時間',
  'siteDetail.endTime': '結束時間',
  'occurrenceBook.new': '新增ob簿',
  'occurrenceBook.edit': '編輯ob簿',
  'occurrenceBook.id': '編號',
  'occurrenceBook.checkpoint': '檢查點',
  'occurrenceBook.expectedTime': '預期時間',
  'occurrenceBook.assignedAt': '預期時間',
  'occurrenceBook.action': '操作',
  'occurrenceBook.shift': '班次',
  'occurrenceBook.selectCheckpoint': '選擇檢查點',
  'occurrenceBook.selectShift': '選擇班次',
  'occurrenceBook.tolerance': '容差（分鐘）',
  'occurrenceBook.failedToFetch': '獲取ob簿失敗',
  'occurrenceBook.deleted': '已刪除',
  'occurrenceBook.updated': '已更新',
  'occurrenceBook.created': '已創建',
  'occurrenceBookRecord.new': '新增ob簿記錄',
  'occurrenceBookRecord.edit': '編輯ob簿記錄',
  'occurrenceBookRecord.id': '編號',
  'occurrenceBookRecord.obNumber': 'OB編號',
  'occurrenceBookRecord.expectedTime': '預期時間',
  'occurrenceBookRecord.checkpoint': '檢查點',
  'occurrenceBookRecord.attendanceTimestamp': '考勤時間戳',
  'occurrenceBookRecord.action': '操作',
  'occurrenceBookRecord.occurrenceBook': 'ob簿',
  'occurrenceBookRecord.selectOccurrenceBook': '選擇ob簿',
  'occurrenceBookRecord.staff': '員工',
  'occurrenceBookRecord.selectStaff': '選擇員工',
  'occurrenceBookRecord.selectCheckpoint': '選擇檢查點',
  'occurrenceBookRecord.approved': '已批准',
  'occurrenceBookRecord.timestamp': '時間戳',
  'occurrenceBookRecord.failedToFetch': '獲取ob簿記錄失敗',
  'occurrenceBookRecord.deleted': '已刪除',
  'occurrenceBookRecord.updated': '已更新',
  'occurrenceBookRecord.created': '已創建',
  'occurrenceBookRecord.dateRange': '日期範圍',
  'occurrenceBookRecord.selectApprovalStatus': '全部',
  'occurrenceBookRecord.notApproved': '未批准',
  'occurrenceBookRecord.filter': '篩選',
  'occurrenceBookRecord.reset': '重置',

  // Public Holiday Management
  'holidayManagement.title': '公共假期管理',
  'holidayManagement.content': '管理組織的公共假期',
  'holidayManagement.holidayList': '假期列表',
  'holidayManagement.addNewHoliday': '新增假期',
  'holidayManagement.editHoliday': '編輯假期',
  'holidayManagement.addHoliday': '新增假期',
  'holidayManagement.createSuccess': '假期建立成功',
  'holidayManagement.updateSuccess': '假期更新成功',
  'holidayManagement.deleteSuccess': '假期刪除成功',
  'holidayManagement.deleteFailed': '刪除失敗',
  'holidayManagement.operationFailed': '操作失敗',
  'holidayManagement.deleteConfirm': '您確定要刪除此假期嗎？',
  'holidayManagement.name': '假期名稱',
  'holidayManagement.description': '描述',
  'holidayManagement.date': '日期',
  'holidayManagement.countryCode': '國家',
  'holidayManagement.stateCode': '州/地區',
  'holidayManagement.isNational': '國家假期',
  'holidayManagement.status': '狀態',
  'holidayManagement.action': '操作',
  'holidayManagement.edit': '編輯',
  'holidayManagement.delete': '刪除',
  'holidayManagement.yes': '是',
  'holidayManagement.no': '否',
  'holidayManagement.active': '啟用',
  'holidayManagement.inactive': '未啟用',
  'holidayManagement.searchName': '搜尋假期名稱',
  'holidayManagement.searchDescription': '搜尋描述',
  'holidayManagement.holidayName': '假期名稱',
  'holidayManagement.pleaseEnterHolidayName': '請輸入假期名稱',
  'holidayManagement.pleaseSelectDate': '請選擇日期',
  'holidayManagement.pleaseSelectCountry': '請選擇國家',
  'holidayManagement.pleaseSelectState': '請選擇州/地區',
  'holidayManagement.isActive': '啟用',
  'holidayManagement.showing': '顯示',
  'holidayManagement.of': '共',
  'holidayManagement.items': '項',

  // 香港公共假期名稱
  'holidayManagement.holidayNames.newYearsDay': '元旦',
  'holidayManagement.holidayNames.lunarNewYearsDay': '農曆新年',
  'holidayManagement.holidayNames.secondDayOfLunarNewYear': '農曆新年第二天',
  'holidayManagement.holidayNames.thirdDayOfLunarNewYear': '農曆新年第三天',
  'holidayManagement.holidayNames.chingMingFestival': '清明節',
  'holidayManagement.holidayNames.goodFriday': '耶穌受難節',
  'holidayManagement.holidayNames.dayFollowingGoodFriday': '耶穌受難節翌日',
  'holidayManagement.holidayNames.easterMonday': '復活節星期一',
  'holidayManagement.holidayNames.labourDay': '勞動節',
  'holidayManagement.holidayNames.buddhaBirthday': '佛誕',
  'holidayManagement.holidayNames.tuenNgFestival': '端午節',
  'holidayManagement.holidayNames.hkEstablishmentDay': '香港特別行政區成立紀念日',
  'holidayManagement.holidayNames.nationalDay': '國慶日',
  'holidayManagement.holidayNames.dayFollowingMidAutumn': '中秋節翌日',
  'holidayManagement.holidayNames.chungYeungFestival': '重陽節',
  'holidayManagement.holidayNames.christmasDay': '聖誕節',
  'holidayManagement.holidayNames.firstWeekdayAfterChristmas': '聖誕節後第一個週日',
  'holidayManagement.quickAddCommonHoliday': '快速新增常見假期',
  'holidayManagement.originalName': '原名',

  // Staff 468 Rule Tooltip
  'staff468Rule.loading': '正在載入工作時數...',
  'staff468Rule.error': '錯誤',
  'staff468Rule.noData': '暫無資料',
  'staff468Rule.workingHoursSummary': '工作時數摘要 (4週)',
  'staff468Rule.totalHours': '總時數:',
  'staff468Rule.threshold': '閾值:',
  'staff468Rule.extraHours': '超時:',
  'staff468Rule.exceedsRule': '⚠️ 超出468規則',
  'staff468Rule.withinRule': '✅ 符合468規則',
  'staff468Rule.holidayCompliance': '假期合規 (7天規則)',
  'staff468Rule.complianceRate': '合規率:',
  'staff468Rule.compliantPeriods': '合規期間:',
  'staff468Rule.violations': '違規:',
  'staff468Rule.holidayCompliant': '✅ 假期合規',
  'staff468Rule.holidayViolation': '⚠️ 假期違規',
  'staff468Rule.violationPeriods': '違規期間:',
  'staff468Rule.days': '天',
  'staff468Rule.moreViolations': '... 還有 {count} 個違規',
  'staff468Rule.calculationPeriod': '計算期間:',
  'staff468Rule.recentAssignments': '最近排班 ({count}):',
  'staff468Rule.moreAssignments': '... 還有 {count} 個排班',
  'staff468Rule.ruleViolation': '⚠️ 468規則違規',
  'staff468Rule.ruleViolationMessage':
    '此員工在過去4週內已超過68小時閾值。新排班可能需要額外批准。',
  'staff468Rule.holidayViolationTitle': '⚠️ 假期合規違規',
  'staff468Rule.holidayViolationMessage':
    '此員工在每7天期間內沒有至少一天假期。請考慮安排休假或調整排班。',
  'staff468Rule.overnight': '通宵',
  'staff468Rule.staff': '員工:',

  // Shift Detail Tooltip Messages
  'shiftDetail.cannotAssignThreshold':
    '無法分配班次：員工已超過468規則閾值（4週內68小時）。需要額外批准。',
  'shiftDetail.cannotAssignHoliday':
    '無法分配班次：員工假期合規違規（7天期間內無假期）。請考慮安排休假或調整排班。',
  'shiftDetail.assignToThisShift': '分配到此班次',
  'shiftDetail.assignToOtherShift': '分配到其他班次',
  'shiftDetail.markAsLeave': '標記為休假',
  'shiftDetail.ruleAndHolidayViolated': ' (468規則和假期合規違規)',
  'shiftDetail.ruleExceeded': ' (468規則超出)',
  'shiftDetail.holidayViolated': ' (假期合規違規)',

  // Shift Detail Export
  'shiftDetail.exportExcel': '匯出Excel',
  'shiftDetail.exportSuccess': '匯出成功',
  'shiftDetail.exportError': '匯出失敗',

  // Staff Assignment Export
  'staffAssignment.backToShiftAssignment': '返回班次分配',
  'staffAssignment.viewShiftDetail': '查看班次詳情',
  'staffAssignment.selectShiftForDetail': '選擇要查看詳情的班次',
  'staffAssignment.viewDetail': '查看詳情',
  'staffAssignment.selectShiftMessage': '請選擇您想要查看詳情的班次：',
  'staffAssignment.site': '站點',
  'staffAssignment.selectSite': '選擇站點',
  'staffAssignment.shift': '班次',
  'staffAssignment.selectShift': '選擇班次',
  'staffAssignment.leaveType': '請假類型',
  'staffAssignment.reason': '原因',
  'staffAssignment.preferredShifts': '首選班次',
  'staffAssignment.clickForOptions': '點擊查看選項',
  'staffAssignment.exportExcel': '匯出Excel',
  'staffAssignment.exportSuccess': '匯出成功',
  'staffAssignment.exportError': '匯出失敗',

  // Staff Assignment Additional Translations
  'staffAssignment.assignShift': '分配班次',
  'staffAssignment.assignLeave': '分配請假',
  'staffAssignment.editAssignment': '編輯排班',
  'staffAssignment.removeAssignment': '移除排班',
  'staffAssignment.updateLeave': '更新請假',
  'staffAssignment.deleteLeave': '刪除請假',
  'staffAssignment.editLeave': '編輯請假',
  'staffAssignment.addLeave': '添加請假',
  'staffAssignment.deleteLeaveTitle': '刪除請假',
  'staffAssignment.deleteLeaveMessage': '確定要刪除此請假嗎？',
  'staffAssignment.leaveDetails': '請假詳情',
  'staffAssignment.delete': '刪除',
  'staffAssignment.selectShiftPlaceholder': '選擇班次',
  'staffAssignment.assignmentRemoved': '排班移除成功',
  'staffAssignment.assignmentRemoveFailed': '排班移除失敗',
  'staffAssignment.leaveUpdated': '請假更新成功',
  'staffAssignment.leaveCreated': '請假創建成功',
  'staffAssignment.leaveProcessFailed': '請假處理失敗',
  'staffAssignment.leaveDeleted': '請假刪除成功',
  'staffAssignment.leaveDeleteFailed': '請假刪除失敗',
  'staffAssignment.manageLeave': '管理請假',
  'staffAssignment.assignShiftTitle': '分配班次',
  'staffAssignment.siteShift': '站點 - 班次',
  'staffAssignment.employeeId': '員工編號',
  'staffAssignment.active': '在職',
  'staffAssignment.inactive': '離職',
  'staffAssignment.date': '日期',
  'staffAssignment.type': '類型',
  'staffAssignment.statutoryHoliday': '法定節假日',
  'staffAssignment.annualLeave': '年假',
  'staffAssignment.noPayLeave': '無薪假',
  'staffAssignment.regularHoliday': '例假',
  'staffAssignment.compensationLeave': '補假',
  'staffAssignment.absenceWithoutLeave': '曠工',
  'staffAssignment.sickLeave': '病假',
  'staffAssignment.unpaidSickLeave': '無薪病假',

  // Attendance Management Export
  'attendance.exportExcel': '匯出Excel',
  'attendance.exportMonthly': '匯出月度考勤',
  'attendance.exportSuccess': '考勤資料匯出成功',
  'attendance.exportError': '考勤資料匯出失敗',
  'attendance.exportTooltip': '匯出月度考勤記錄到Excel檔案',
  'attendance.selectMonth': '選擇匯出月份',

  // Version Management
  'versionManagement.title': '應用版本管理',
  'versionManagement.versionList': '版本列表',
  'versionManagement.createVersion': '創建版本',
  'versionManagement.editVersion': '編輯版本',
  'versionManagement.versionDetail': '版本詳情',
  'versionManagement.versionNumber': '版本號',
  'versionManagement.versionName': '版本名稱',
  'versionManagement.platform': '平台',
  'versionManagement.releaseType': '發布類型',
  'versionManagement.status': '狀態',
  'versionManagement.releaseSummary': '發布摘要',
  'versionManagement.releaseNotes': '發布說明',
  'versionManagement.features': '新功能',
  'versionManagement.bugFixes': '錯誤修復',
  'versionManagement.improvements': '改進',
  'versionManagement.breakingChanges': '破壞性變更',
  'versionManagement.minOsVersion': '最低系統版本',
  'versionManagement.maxOsVersion': '最高系統版本',
  'versionManagement.plannedReleaseDate': '計劃發布日期',
  'versionManagement.forceUpdate': '強制更新',
  'versionManagement.critical': '關鍵',
  'versionManagement.active': '激活',
  'versionManagement.inactive': '未激活',
  'versionManagement.buildNumber': '構建號',
  'versionManagement.fileInfo': '文件信息',
  'versionManagement.viewFileInfo': '查看文件信息',
  'versionManagement.downloadFile': '下載文件',
  'versionManagement.flags': '標誌',
  'versionManagement.createdAt': '創建時間',
  'versionManagement.updatedAt': '更新時間',
  'versionManagement.actions': '操作',
  'versionManagement.edit': '編輯',
  'versionManagement.detail': '詳情',
  'versionManagement.approve': '批准',
  'versionManagement.release': '發布',
  'versionManagement.deprecate': '棄用',
  'versionManagement.approveConfirm': '確定要批准此版本嗎？',
  'versionManagement.releaseConfirm': '確定要發布此版本嗎？',
  'versionManagement.deprecateConfirm': '確定要棄用此版本嗎？',
  'versionManagement.createSuccess': '版本創建成功',
  'versionManagement.createError': '版本創建失敗',
  'versionManagement.updateSuccess': '版本更新成功',
  'versionManagement.updateError': '版本更新失敗',
  'versionManagement.approveSuccess': '版本批准成功',
  'versionManagement.approveError': '版本批准失敗',
  'versionManagement.releaseSuccess': '版本發布成功',
  'versionManagement.releaseError': '版本發布失敗',
  'versionManagement.deprecateSuccess': '版本棄用成功',
  'versionManagement.deprecateError': '版本棄用失敗',
  'versionManagement.downloadSuccess': '文件下載成功',
  'versionManagement.downloadError': '文件下載失敗',
  'versionManagement.uploadSuccess': '文件上傳成功',
  'versionManagement.uploadError': '文件上傳失敗',
  'versionManagement.removeFileSuccess': '文件刪除成功',
  'versionManagement.removeFileError': '文件刪除失敗',
  'versionManagement.getFileInfoError': '獲取文件信息失敗',
  'versionManagement.basicInfo': '基本信息',
  'versionManagement.timestamps': '時間戳',
  'versionManagement.releaseDate': '發布日期',
  'versionManagement.osRequirements': '系統要求',
  'versionManagement.filename': '文件名',
  'versionManagement.fileSize': '文件大小',
  'versionManagement.checksum': '校驗和',
  'versionManagement.uploadedAt': '上傳時間',
  'versionManagement.uploadedBy': '上傳者',
  'versionManagement.noFileAttached': '此版本未附加文件',
  'versionManagement.uploadFile': '上傳文件',
  'versionManagement.removeFile': '刪除文件',
  'versionManagement.removeFileConfirm': '確定要刪除此文件嗎？',
  'versionManagement.versionNumberRequired': '請輸入版本號',
  'versionManagement.platformRequired': '請選擇平台',
  'versionManagement.releaseTypeRequired': '請選擇發布類型',
  'versionManagement.appFile': '應用文件（可選）',
  'versionManagement.fileUploadHelp': '上傳此版本的應用文件（APK、IPA、ZIP等）',
  'versionManagement.selectFile': '選擇文件',
  'versionManagement.selectedFile': '已選擇文件',
};
